'use client';

import { useEffect, useState } from 'react';

type ClientChromeModule = typeof import('@/components/ClientChrome');

export function DeferredClientChrome({ yandexMetrikaEnabled }: { yandexMetrikaEnabled: boolean }) {
  const [ClientChrome, setClientChrome] = useState<ClientChromeModule['ClientChrome'] | null>(null);

  useEffect(() => {
    let cancelled = false;

    void import('@/components/ClientChrome').then((mod) => {
      if (!cancelled) {
        setClientChrome(() => mod.ClientChrome);
      }
    });

    return () => {
      cancelled = true;
    };
  }, []);

  return ClientChrome ? <ClientChrome yandexMetrikaEnabled={yandexMetrikaEnabled} /> : null;
}
